import {InjectionToken} from '@angular/core';

export interface AmChartsCredentials {
    AMCHARTS_KEY: string;
}

export const AM_CHARTS_CREDENTIALS = new InjectionToken<AmChartsCredentials>('AM_CHARTS_CREDENTIALS');
